import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from 'react-use';
import Snackbar from 'components/consumer/Snackbar';

// This allows a Snackbar with a specified storageKey to be shown once to a
// customer. It will continue to be shown until the customer clicks the close
// button, after which it will be hidden (because we store it in local storage)
const SnackbarShowOnce = t0 => {
  const $ = _c(6);
  const {
    children,
    storageKey
  } = t0;
  const [isOpen, setIsOpen] = useLocalStorage(`SnackbarShowOnce-isOpen-${storageKey}`, true);
  let t1;
  if ($[0] !== setIsOpen) {
    t1 = () => {
      setIsOpen(false);
    };
    $[0] = setIsOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== isOpen || $[4] !== t1) {
    t2 = <Snackbar isOpen={isOpen} onClose={t1}>{children}</Snackbar>;
    $[2] = children;
    $[3] = isOpen;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
SnackbarShowOnce.propTypes = {
  children: PropTypes.node.isRequired,
  storageKey: PropTypes.string.isRequired
};
export default SnackbarShowOnce;